export function truncateFileName(name = '', maxBaseLength = 12) {
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex === -1) return name;
  
    const base = name.slice(0, dotIndex);
    const ext = name.slice(dotIndex);
  
    if (base.length <= maxBaseLength) return name;
  
    const start = base.slice(0, 5);
    const end = base.slice(-4);
    return `${start}...${end}${ext}`;
  }